// Preparación para la tienda en línea: mismos criterios que el backend
// (`_storefront_readiness` en catalog.py). `specTemplate` viene de useSpecSchemas().schemaFor(category).
export function storefrontReadiness(p, specTemplate = []) {
  const photos = Array.isArray(p.photos) ? p.photos.filter(Boolean) : [];
  const slots = [
    { key: "name", label: "Nombre del producto", ok: !!(p.name || "").trim() },
    { key: "category", label: "Categoría", ok: !!(p.category || "").trim() },
    { key: "store_price", label: "Precio de tienda", ok: Number(p.store_price || 0) > 0 },
    { key: "photos", label: "Al menos 1 foto", ok: photos.length > 0 || !!p.photos_url || !!(p.cover_photo || "").trim() },
    { key: "use_cases", label: "Uso ideal (al menos 1)", ok: (p.use_cases || []).length > 0 },
    { key: "short_tagline", label: "Slogan corto", ok: !!(p.short_tagline || "").trim() },
  ];
  const req = (specTemplate || []).filter((f) => f.required);
  if (req.length > 0) {
    req.forEach((f) => slots.push({ key: `spec_${f.key}`, label: `Ficha técnica: ${f.label}`, ok: !!String(p.specs?.[f.key] || "").trim() }));
  } else if ((specTemplate || []).length > 0) {
    slots.push({ key: "specs", label: "Ficha técnica: al menos 1 dato", ok: Object.values(p.specs || {}).some((v) => String(v || "").trim()) });
  }
  // Sin esquema para la categoría no se exige ficha técnica.
  const missing = slots.filter((s) => !s.ok);
  return { filled: slots.length - missing.length, total: slots.length, missing, ready: missing.length === 0 };
}
